<template>
    <div id="histicContainer">
        <historic-chart type="temp" :chart-data="chartData" v-loading="loading"/>
        <historic-chart type="co2" :chart-data="chartData" v-loading="loading"/>
        <!--<historic-chart type="hum" :chart-data="chartData" v-loading="loading"/>-->
        <historic-chart type="moisture" :chart-data="chartData" v-loading="loading"/>
    </div>
</template>

<script>
    import api from "../../utils/api/api";
    import historicChart from "./charts/historicChart";
    import unitConverter from "../../utils/unitConverter";

    export default {
        name: "HistoricContainer",
        components: {
            "historic-chart": historicChart
        },
        props: {
            siteId: {
                type: String,
                required: true,
            },
            silo: {
                type: Object,
                required: true
            },
            from: {
                type: Date,
                required: true,
            },
            to: {
                type: Date,
                required: true,
            }
        },
        data: function () {
            return {
                data: [],
                noDuplicateData: [],
                pendingSectionResult: [],
                sections: undefined,
                loading: false,
                chartData: [],
                offsetHoras: 0

            }
        },
        watch: {
            pendingSectionResult: function (newVal) 
            {
                //console.log("newval: ",newVal);
                let awaitingResult = newVal.filter(value => {
                    return (value.awaiting === undefined || value.awaiting);
                });

                if (awaitingResult.length !== 0 && this.loadingInstance === undefined) {
                    this.loading = true;
                }
                if (awaitingResult.length === 0) {
                    for (let i = 0; i < newVal.length; i++) {
                        this.data.splice(i, 1, newVal[i].data)
                    }
                    if (this.loading) {
                        this.loading = false;
                    }
                }
            },
            data: function (newVal) {
                if (newVal.length !== 0) {
                    this.noDuplicateData = this.addDateObj(newVal);
                    this.chartData = this.buildChartData(this.noDuplicateData);
                }
            },
            to: function (newVal) {
                this.loadSections(this.siteId, this.silo.id, this.sections, this.from, newVal);
            },
            silo: function (newVal) {
                api.getSilo(this.siteId, newVal.id).then(value => {
                    if (value.silo !== undefined) {
                        this.sections = value.silo.sections;
                        this.loadSections(this.siteId, newVal.id, this.sections, this.from, this.to);
                    }
                });
            },
        },
        mounted() {
            this.offsetHoras = this.$store.state.user.timezone;
            if (this.silo !== undefined) {
                api.getSilo(this.siteId, this.silo.id).then(value => {
                    if (value.silo !== undefined) {
                        this.sections = value.silo.sections;
                        this.loadSections(this.siteId, this.silo.id, this.sections, this.from, this.to);
                    }

                });
            }

        },
        computed: {
            datesArray: function () {
                let amountOfDays = (this.to.getTime() - this.from.getTime()) / (1000 * 3600 * 24);
                amountOfDays = Math.round(amountOfDays) + 1;
                let array = [];
                for (let i = 0; i < amountOfDays; i++) {
                    let date = new Date(this.from.getTime() + (1000 * 3600 * 24 * i));
                    array.push(new Date(date.getFullYear(), date.getMonth(), date.getDate()));
                }
                return array;
            },
        },
        methods: {
            loadSections(siteId, siloId, sections, from, to) {
                this.data = []
                from.setHours(0, 0, 0, 0);
                to.setHours(23, 59, 59, 999);
                if(this.$store.state.viewDetails == true)
                {
                    if (sections !== undefined && sections.length > 0) 
                    {
                        const fromStr = Math.trunc(from.getTime() / 1000);
                        const totStr = Math.trunc(to.getTime() / 1000);
                        this.pendingSectionResult = new Array(sections.length);
                        for (let i = 0; i < sections.length; i++) 
                        {
                            this.pendingSectionResult.splice(i, 1, {awaiting: true, data: []});
                            api.getHistorics(siteId, siloId, sections[i].seccion, fromStr, totStr).then(value => {
                                this.pendingSectionResult.splice(i, 1, {awaiting: false, data: value.history});
                            }).catch(reason => {
                                this.pendingSectionResult.splice(i, 1, {awaiting: false, data: []});
                            });
                        }
                    }
                }
                else 
                {
                    const fromStr = Math.trunc(from.getTime() / 1000);
                    const totStr = Math.trunc(to.getTime() / 1000);
                    this.pendingSectionResult = new Array(1);
                    this.pendingSectionResult.splice(0, 1, {awaiting: true, data: []});
                    api.getPromHistorics(siteId, siloId, fromStr, totStr).then(value => {
                                this.pendingSectionResult.splice(0, 1, {awaiting: false, data: value.history});
                            }).catch(reason => {
                                this.pendingSectionResult.splice(0, 1, {awaiting: false, data: []});
                            });
                }

            },
            addDateObj(data) {
                let newData = [];
                let newDate;
                data.forEach(section => {
                    section.forEach(d => {
                        //d.dateObj = new Date(d.date * 1000);
                        //console.log("d.date: ",d.date);
                        newDate = new Date((d.date + (this.offsetHoras * 3600)));
                        //console.log("newDate: ",newDate);
                        d.dateObj = new Date(newDate  * 1000);
                        //d.dateObj = new Date((d.date) * 1000);
                    });

                    newData.push(section);

                });
                return newData;

            },
            buildChartData(data) {

                let result = new Array(data.length);
                for (let i = 0; i < result.length; i++) 
                {
                    result[i] = [];
                    let section = data[i];
                    for (let j = 0; j < this.datesArray.length; j++) 
                    {
                        let date = this.datesArray[j];

                        let metricData = undefined;
                        if (section !== undefined) 
                        {
                            metricData = section.filter(obj => 
                            {
                                return obj !== undefined
                                    && obj.dateObj !== undefined
                                    && obj.dateObj.getFullYear() === date.getFullYear()
                                    && obj.dateObj.getMonth() === date.getMonth()
                                    && obj.dateObj.getDate() === date.getDate()
                            });
                        }
                        if (metricData === undefined || metricData.length === 0) 
                        {
                            metricData = [{
                                dateObj: date,
                                hum: undefined,
                                temp: undefined,
                                co2: undefined,
                                moisture: undefined
                            }]
                        }

                        metricData.forEach(md => 
                        {
                            if(md.hum == "-")
                            {
                                md.hum = undefined;
                            }
                            if(md.temp == "-")
                            {
                                md.temp = undefined;
                            }
                            if(md.co2 == "-")
                            {
                                md.co2 = undefined;
                            }
                            if(md.moisture == "-")
                            {
                                md.moisture = undefined;
                            }
                            md.hum = unitConverter.convertTo("hum", md.hum, this.$store.getters.unit("hum"));
                            md.temp = unitConverter.convertTo("temp", md.temp, this.$store.getters.unit("temp"));
                            md.co2 = unitConverter.convertTo("co2", md.co2, this.$store.getters.unit("co2"));
                            md.moisture = unitConverter.convertTo("moisture", md.moisture, this.$store.getters.unit("moisture"));
                            result[i].push(md);
                        });
                    }
                }
                return result;

            },
        },

    }
</script>

<style scoped lang="scss">


</style>
